export default async function getApp({ context, nextMiddleware }) {
  console.log('getApp');
  try {
    await context.store.appStore.getApp(context.to.params.id);
    await context.store.appStore.getClientDocs(context.to.params.id);
    await context.store.appStore.getFieldDocumentTypes(context.to.params.id);
    await context.store.appStore.getFieldDocs(context.to.params.id);
    await context.store.appStore.getQuestionnaire(context.to.params.id);
  } catch (e) {
    console.error(e);
    return context.next(false);
  }
  return nextMiddleware();
}
